import { Component, HostBinding, OnInit } from '@angular/core';
import { AppService } from '../../../../services/app.service';
import { ResourceService } from '../../../../services/resources/resource.service';
import { ResourceSearchRequest } from '../../../../models/net/request/resource-search-request';
import { ResourceSearchResult } from '../../../../models/net/result/resource-search-result';
import { ActionButton } from '../../../../models/app/action-button';

@Component({
    selector: 'app-talent-start',
    templateUrl: './talent-start.component.html',
    styleUrls: ['./talent-start.component.css', '../../../../app.component.css']
})

export class TalentStartComponent implements OnInit {

    public actionButtons: ActionButton[] = [];
    public featuredResources: ResourceSearchResult[] = [];

    @HostBinding("class.component-flex-vertical-fill") addClass = true;

    public constructor(public appService: AppService, public resourceService: ResourceService) {

        this.actionButtons.push(new ActionButton("APP FEED", "", "", "", false));
        this.appService.setActionsDataSource(this.actionButtons);
    }

    public ngOnInit(): void {

        const searchRequest: ResourceSearchRequest = new ResourceSearchRequest();

        searchRequest.FirstName.IsWildPrefix = true;
        searchRequest.FirstName.IsWildSuffix = true;
        searchRequest.LastName.IsWildPrefix = true;
        searchRequest.LastName.IsWildSuffix = true;
        searchRequest.IsAdvancedSearch = true;

        this.resourceService.search(searchRequest).subscribe((r: ResourceSearchResult[] | null) => {

            if (r != null) {

                this.featuredResources = r;
            }
        });
    }

    public editResource = (resourceId: number): void => {

        const route: string = "resource/" + resourceId.toString();

        this.appService.navigateTo(route, "");
    }
}
